(function () {
  const leftArrowSVGString =
    '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';
  const closeSvgString =
    '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path></svg>';

  function initMasonryLightboxes() {
    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') return;

    document.querySelectorAll('[data-masonry-gallery][data-enable-lightbox="true"]').forEach((gallery) => {
      if (gallery.dataset.lightboxInit === 'true') return;
      gallery.dataset.lightboxInit = 'true';

      const lightbox = new PhotoSwipeLightbox({
        gallery,
        children: 'a.gl-masonry-gallery__lightbox-link',
        bgOpacity: 1,
        showHideAnimationType: 'zoom',
        loop: true,
        counter: true,
        zoom: true,
        bgClickAction: 'close',
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: leftArrowSVGString,
        closeSVG: closeSvgString,
        pswpModule: PhotoSwipe,
      });

      // Pull the hosted video URL/poster off the anchor so video blocks can
      // be shown as slides (PhotoSwipe only reads image data by default).
      lightbox.addFilter('domItemData', (itemData, element, linkEl) => {
        if (linkEl && linkEl.dataset.pswpType === 'video') {
          itemData.videoSrc = linkEl.dataset.pswpVideoSrc;
          itemData.videoPoster = linkEl.dataset.pswpPoster || '';
        }
        return itemData;
      });

      // Render a real <video> for video slides instead of an image.
      lightbox.on('contentLoad', (e) => {
        const { content } = e;
        if (content.type !== 'video' || !content.data.videoSrc) return;
        e.preventDefault();

        const wrap = document.createElement('div');
        wrap.className = 'pswp__video-wrap';

        const video = document.createElement('video');
        video.className = 'pswp__video';
        video.src = content.data.videoSrc;
        if (content.data.videoPoster) video.poster = content.data.videoPoster;
        video.controls = true;
        video.playsInline = true;
        video.loop = true;
        video.preload = 'auto';

        wrap.appendChild(video);
        content.element = wrap;
      });

      // Autoplay when the video slide becomes active; pause when leaving it.
      const getSlideVideo = (content) =>
        content && content.element ? content.element.querySelector('video') : null;

      lightbox.on('contentActivate', (e) => {
        const video = e.content.type === 'video' ? getSlideVideo(e.content) : null;
        if (video) video.play().catch(() => {});
      });

      lightbox.on('contentDeactivate', (e) => {
        const video = e.content.type === 'video' ? getSlideVideo(e.content) : null;
        if (video) video.pause();
      });

      lightbox.on('close', () => {
        document.querySelectorAll('.pswp__video').forEach((video) => video.pause());
      });

      lightbox.init();

      // Capture-phase guard: the gallery thumbnails are real <a> links so they
      // stay accessible and work without JS. PhotoSwipe only calls
      // preventDefault() when it decides to open, and silently bails (leaving
      // the link to navigate to the raw image URL) whenever a previous
      // instance is still referenced on window.pswp or its own click/index
      // detection misses (mis-targeted taps, double-taps, close animation).
      // We run first, always cancel the navigation, and clear any stale
      // instance so PhotoSwipe's own handler can re-open cleanly.
      gallery.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest('a.gl-masonry-gallery__lightbox-link');
          if (!link || !gallery.contains(link)) return;

          event.preventDefault();

          if (window.pswp && !document.querySelector('.pswp')) {
            try {
              window.pswp.destroy();
            } catch (e) {
              /* no-op */
            }
            window.pswp = undefined;
          }
        },
        true
      );
    });
  }

  document.addEventListener('DOMContentLoaded', initMasonryLightboxes);
  document.addEventListener('shopify:section:load', initMasonryLightboxes);
})();
